import { useIntl } from 'react-intl';
import { useAdvertiserCampaignContext } from 'sonata-platform-components';
import { Selector } from 'sonata-react-components';

import { AgencyGroupSelectorstyled } from './AgencyGroupSelectors.styled';
import { AgencyGroupSelectorsSkeleton } from './AgencyGroupSelectorsSkeleton';

type Props = {
  isDraft?: boolean;
};

function AgencyGroupSelectors({ isDraft = true }: Props) {
  const { formatMessage } = useIntl();
  const {
    getMediaAgencyOptions,
    getMediaGroupOptions,
    handleMediaAgencyChange,
    handleMediaGroupChange,
    isLoading,
    mediaGroupsPermission,
    mediaInfoSelected
  } = useAdvertiserCampaignContext();

  const { agency, group } = mediaInfoSelected || {};

  if (isLoading) {
    return <AgencyGroupSelectorsSkeleton />;
  }

  return (
    <AgencyGroupSelectorstyled>
      {mediaGroupsPermission && (
        <Selector
          className="advertiserCampaignSelector__groupSelector"
          isDisabled={!isDraft}
          label={formatMessage({
            defaultMessage: 'Group',
            id: 'advertisers.form.group.label'
          })}
          onChange={handleMediaGroupChange}
          options={getMediaGroupOptions()}
          showSearch
          type="simple"
          value={[
            {
              id: group?._id || '',
              label: group?.name || ''
            }
          ]}
        />
      )}
      <Selector
        className="advertiserCampaignSelector__agencySelector"
        isDisabled={!isDraft}
        label={formatMessage({
          defaultMessage: 'Agency',
          id: 'advertisers.form.agency.label'
        })}
        onChange={handleMediaAgencyChange}
        options={getMediaAgencyOptions() || []}
        showSearch
        type="simple"
        value={[
          {
            id: agency?._id || '',
            label: agency?.name || ''
          }
        ]}
      />
    </AgencyGroupSelectorstyled>
  );
}

export default AgencyGroupSelectors;
